import { DateTime } from "luxon";
import { GameStatus, IStorageGameData } from "../../types";

export const initialStorageData: IStorageGameData = {
  currentGame: {
    gameID: 2,
    guesses: [],
  },
  stat: {
    guesses: [0, 0, 0, 0, 0],
    Played: 0,
    Win: 0,
    CurrentStreak: 0,
    MaxStreak: 0,
    lastGameStatus: GameStatus.VICTORY,
    lastPlayedDate: DateTime.now().minus({ days: 1 }).toFormat("yyyy-MM-dd"),
  },
};

export const stylesForSelect = {
  option: (provided: any) => ({
    ...provided,
    padding: 10,
  }),
  // control: () => ({
  //   border: 'none'
  // }),
  indicatorsContainer: () => ({
    display: "none",
  }),
  placeholder: (provided: any) => ({
    ...provided,
    fontSize: "18px",
  }),
  input: (provided: any) => ({
    ...provided,
    fontSize: "18px",
  }),
  valueContainer: (provided: any) => ({
    ...provided,
    fontSize: "18px",
  }),
  // menuList: () => ({
  //   overflow: "hidden",
  //   maxHeight: "190px",
    
  // }),
};

export const brandles = {
  brands: [
    {
      logoUrl: "samsung.png",
      name: "Samsung",
      date: "6/14",
      category: ["Tech"],
      id: 1,
    },
    {
      logoUrl: "Pizzahut.png",
      name: "Pizza Hut",
      date: "6/15",
      category: ["Food & Beverage"],
      id: 2,
    },
    {
      logoUrl: "NBC.png",
      name: "NBC",
      date: "6/16",
      category: ["Entertainment"],
      id: 3,
    },
    {
      logoUrl: "FIFA.png",
      name: "FIFA",
      date: "6/17",
      category: ["Entertainment"],

      id: 4,
    },
    {
      logoUrl: "fernet.jpg",
      name: "Fernet",
      date: "6/18",
      category: ["Food & Beverage"],
      id: 5,
    },
    {
      logoUrl: "Cartier.png",
      name: "Cartier",
      date: "6/19",
      category: ["Retail"],
      id: 6,
    },
    {
      logoUrl: "oakley.png",
      name: "Oakley",
      date: "6/20",
      category: ["CPG"],
      id: 7,
    },
    {
      logoUrl: "NHL.png",
      name: "NHL",
      date: "6/21",
      category: ["Entertainment"],
      id: 8,
    },
    {
      logoUrl: "Goldmansachs.png",
      name: "Goldman Sachs",
      date: "6/22",
      category: ["Financial Services"],
      id: 9,
    },
    {
      logoUrl: "hyatt.png",
      name: "Hyatt",
      date: "6/23",
      category: ["Hospitality"],
      id: 10,
    },
    {
      logoUrl: "TESCO.jpg",
      name: "Tesco",
      date: "6/24",
      category: ["Retail"],
      id: 11,
    },
    {
      logoUrl: "burgerking.png",
      name: "Burger King",
      date: "6/25",
      category: ["Food & Beverage"],
      id: 12,
    },
    {
      logoUrl: "deloitte.png",
      name: "Deloitte",
      date: "6/26",
      category: ["Professional Services"],
      id: 13,
    },
    {
      logoUrl: "Panasonic.jpg",
      name: "Panasonic",
      date: "6/27",
      category: ["Tech"],
      id: 14,
    },
    {
      logoUrl: "circlek.png",
      name: "Circle K",
      date: "6/28",
      category: ["Retail"],
      id: 15,
    },
    {
      logoUrl: "Cadillac.png",
      name: "Cadillac",
      date: "6/29",
      category: ["Automotive"],
      id: 16,
    },
    {
      logoUrl: "sony.png",
      name: "Sony",
      date: "6/30",
      category: ["Tech"],
      id: 17,
    },
    {
      logoUrl: "pinduoduo.jpg",
      name: "Pinduoduo",
      date: "7/1",
      category: ["Tech"],
      id: 18,
    },
    {
      logoUrl: "ups.png",
      name: "UPS",
      date: "7/2",
      category: ["Logistics"],
      id: 19,
    },
    {
      logoUrl: "vodafone.jpg",
      name: "Vodafone",
      date: "7/3",
      category: ["Tech"],
      id: 20,
    },
    {
      logoUrl: "nba.jpg",
      name: "NBA",
      date: "7/4",
      category: ["Entertainment"],
      id: 21,
    },
    {
      logoUrl: "GuitarCenter.png",
      name: "Guitar Center",
      date: "7/5",
      category: ["Retail"],
      id: 22,
    },
    {
      logoUrl: "Honda.png",
      name: "Honda",
      date: "7/6",
      category: ["Automotive"],
      id: 23,
    },
    {
      logoUrl: "Tiffany.png",
      name: "Tiffany & Co.",
      date: "7/7",
      category: ["Retail"],
      id: 24,
    },
    {
      logoUrl: "Lego.png",
      name: "Lego",
      date: "7/8",
      category: ["CPG"],
      id: 25,
    },
    {
      logoUrl: "hilton.png",
      name: "Hilton",
      date: "7/9",
      category: ["Hospitality"],
      id: 26,
    },
    {
      logoUrl: "salesforce.png",
      name: "Salesforce",
      date: "7/10",
      category: ["Tech"],
      id: 27,
    },
    {
      logoUrl: "kfc.png",
      name: "KFC",
      date: "7/11",
      category: ["Food & Beverage"],
      id: 28,
    },
    {
      logoUrl: "ADP.png",
      name: "ADP",
      date: "7/12",
      category: ["Tech"],
      id: 29,
    },
    {
      logoUrl: "xfinity.png",
      name: "xfinity",
      date: "7/13",
      category: ["Tech"],
      id: 30,
    },
    {
      logoUrl: "yahoo.png",
      name: "Yahoo",
      date: "7/14",
      category: ["Tech"],
      id: 31,
    },
    {
      logoUrl: "UnitedHealthcare.jpg",
      name: "United Healthcare",
      date: "7/15",
      category: ["Healthcare"],
      id: 32,
    },
    {
      logoUrl: "monster.jpg",
      name: "Monster",
      date: "7/16",
      category: ["Food & Beverage"],
      id: 33,
    },
    {
      logoUrl: "aetna.png",
      name: "Aetna",
      date: "7/17",
      category: ["Healthcare"],
      id: 34,
    },
    {
      logoUrl: "Seiko.png",
      name: "Seiko",
      date: "7/18",
      category: ["CPG"],
      id: 35,
    },
    {
      logoUrl: "orange.png",
      name: "Orange",
      date: "7/19",
      category: ["Business Services"],
      id: 36,
    },
    {
      logoUrl: "honest.png",
      name: "Honest Company",
      date: "7/20",
      category: ["CPG"],
      id: 37,
    },
    {
      logoUrl: "YETI.png",
      name: "YETI",
      date: "7/21",
      category: ["CPG"],
      id: 38,
    },
    {
      logoUrl: "cisco.jpg",
      name: "Cisco",
      date: "7/22",
      category: ["Information Technology"],
      id: 39,
    },
    {
      logoUrl: "TJmaxx.png",
      name: "TJ Maxx",
      date: "7/23",
      category: ["Retail"],
      id: 40,
    },
    {
      logoUrl: "nokia.png",
      name: "Nokia",
      date: "7/24",
      category: ["Tech"],
      id: 41,
    },
    {
      logoUrl: "Cigna.jpg",
      name: "Cigna",
      date: "7/25",
      category: ["Healthcare"],
      id: 42,
    },
    {
      logoUrl: "Walmart.png",
      name: "Walmart",
      date: "7/26",
      category: ["Retail"],
      id: 43,
    },
    {
      logoUrl: "Chevron.png",
      name: "Chevron",
      date: "7/27",
      category: ["Energy"],
      id: 44,
    },
    {
      logoUrl: "google.png",
      name: "Google",
      date: "7/28",
      category: ["Tech"],
      id: 45,
    },
    {
      logoUrl: "BP.png",
      name: "BP",
      date: "7/29",
      category: ["Energy"],
      id: 46,
    },
    {
      logoUrl: "alaska.png",
      name: "Alaska Airlines",
      date: "7/30",
      category: ["Transportation"],
      id: 47,
    },
    {
      logoUrl: "Samsclub.png",
      name: "Sam's Club",
      date: "7/31",
      category: ["Retail"],
      id: 48,
    },
    {
      logoUrl: "ZARA.png",
      name: "Zara",
      date: "8/1",
      category: ["Retail"],
      id: 49,
    },
    {
      logoUrl: "NorthropGruman.png",
      name: "NORTHROP GRUMMAN",
      date: "8/2",
      category: ["Science"],
      id: 50,
    },
    {
      logoUrl: "Abbott.png",
      name: "Abbott",
      date: "8/3",
      category: ["Science"],
      id: 51,
    },
    {
      logoUrl: "3m.jpg",
      name: "3M",
      date: "8/4",
      category: ["Science"],
      id: 52,
    },
    {
      logoUrl: "HSBC.png",
      name: "HSBC",
      date: "8/5",
      category: ["Financial Services"],
      id: 53,
    },
    {
      logoUrl: "Td.png",
      name: "TD",
      date: "8/6",
      category: ["Financial Services"],
      id: 54,
    },
    {
      logoUrl: "Travelers.png",
      name: "Travelers",
      date: "8/7",
      category: ["Insurance"],
      id: 55,
    },
    {
      logoUrl: "VONS.png",
      name: "Vons",
      date: "8/8",
      category: ["Retail"],
      id: 56,
    },
    {
      logoUrl: "soulcycle.png",
      name: "Soul Cycle",
      date: "8/9",
      category: ["Entertainment"],
      id: 57,
    },
    {
      logoUrl: "1800Tequila.jpeg",
      name: "1800 Tequilla",
      date: "8/10",
      category: ["Food & Beverage"],
      id: 58,
    },
    {
      logoUrl: "eBay.png",
      name: "eBay",
      date: "8/11",
      category: ["Tech"],
      id: 59,
    },
    {
      logoUrl: "ancestry.png",
      name: "Ancestry",
      date: "8/12",
      category: ["Tech"],
      id: 60,
    },
    {
      logoUrl: "AstraZeneca.jpg",
      name: "AstraZeneca",
      date: "8/13",
      category: ["Science"],
      id: 61,
    },
    {
      logoUrl: "abc.jpg",
      name: "ABC",
      date: "8/14",
      category: ["Entertainment"],
      id: 62,
    },
    {
      logoUrl: "Ethereum.png",
      name: "Ethereum",
      date: "8/15",
      category: ["Tech"],
      id: 63,
    },
    {
      logoUrl: "asics.png",
      name: "Asics",
      date: "8/16",
      category: ["CPG"],
      id: 64,
    },
    {
      logoUrl: "ford.png",
      name: "Ford",
      date: "8/17",
      category: ["Automotive"],
      id: 65,
    },
    {
      logoUrl: "Chase.png",
      name: "Chase",
      date: "8/18",
      category: ["Financial Services"],
      id: 66,
    },
    {
      logoUrl: "uniqlo.png",
      name: "Uniqlo",
      date: "8/19",
      category: ["Retail"],
      id: 67,
    },
    {
      logoUrl: "Arbys.png",
      name: "Arby's",
      date: "8/20",
      category: ["Food & Beverage"],
      id: 68,
    },
    {
      logoUrl: "BOSCH.jpg",
      name: "BOSCH",
      date: "8/21",
      category: ["Retail"],
      id: 69,
    },
    {
      logoUrl: "walgreens.png",
      name: "Walgreens",
      date: "8/22",
      category: ["Retail"],
      id: 70,
    },
    {
      logoUrl: "snapchat.png",
      name: "Snapchat",
      date: "8/23",
      category: ["Tech"],
      id: 71,
    },
    {
      logoUrl: "Safeway.png",
      name: "Safeway",
      date: "8/24",
      category: ["Retail"],
      id: 72,
    },
    {
      logoUrl: "24hourfitness.png",
      name: "24 Hour Fitness",
      date: "8/25",
      category: ["Entertainment"],
      id: 73,
    },
    {
      logoUrl: "Anthem.jpg",
      name: "Anthem",
      date: "8/26",
      category: ["Healthcare"],
      id: 74,
    },
    {
      logoUrl: "Ross.jpg",
      name: "Ross",
      date: "8/27",
      category: ["Retail"],
      id: 75,
    },
    {
      logoUrl: "razer.png",
      name: "Razer",
      date: "8/28",
      category: ["Tech"],
      id: 76,
    },
    {
      logoUrl: "loreal.jpg",
      name: "L'ORÉAL",
      date: "8/29",
      category: ["Retail"],
      id: 77,
    },
    {
      logoUrl: "renault.png",
      name: "Renault",
      date: "8/30",
      category: ["Automotive"],
      id: 78,
    },
    {
      logoUrl: "newbalance.png",
      name: "New Balance",
      date: "8/31",
      category: ["CPG"],
      id: 79,
    },
    {
      logoUrl: "microsoft.jpg",
      name: "Microsoft",
      date: "9/1",
      category: ["Tech"],
      id: 80,
    },
    {
      logoUrl: "publix.png",
      name: "Publix",
      date: "9/2",
      category: ["Retail"],
      id: 81,
    },
    {
      logoUrl: "Costco.png",
      name: "Costco",
      date: "9/3",
      category: ["Retail"],
      id: 82,
    },
    {
      logoUrl: "Target.png",
      name: "Target",
      date: "9/4",
      category: ["Retail"],
      id: 83,
    },
    {
      logoUrl: "Tide.png",
      name: "Tide",
      date: "9/5",
      category: ["CPG"],
      id: 84,
    },
    {
      logoUrl: "amazon.jpg",
      name: "Amazon",
      date: "9/6",
      category: ["Tech"],
      id: 85,
    },
    {
      logoUrl: "MARSWRigley.png",
      name: "Mars Wrigley",
      date: "9/7",
      category: ["Food & Beverage"],
      id: 86,
    },
    {
      logoUrl: "aramco.png",
      name: "Aramco",
      date: "9/8",
      category: ["Energy"],
      id: 87,
    },
    {
      logoUrl: "Folgers.png",
      name: "Folgers",
      date: "9/9",
      category: ["Food & Beverage"],
      id: 88,
    },
    {
      logoUrl: "Lenovo.png",
      name: "Lenovo",
      date: "9/10",
      category: ["Tech"],
      id: 89,
    },
    {
      logoUrl: "shell.png",
      name: "Shell",
      date: "9/11",
      category: ["Energy"],
      id: 90,
    },
    {
      logoUrl: "lazboy.png",
      name: "LazyBoy",
      date: "9/12",
      category: ["Retail"],
      id: 91,
    },
    {
      logoUrl: "MorganStanley.png",
      name: "Morgan Stanley",
      date: "9/13",
      category: ["Financial Services"],
      id: 92,
    },
    {
      logoUrl: "cholula.png",
      name: "Cholula",
      date: "9/14",
      category: ["Food & Beverage"],
      id: 93,
    },
    {
      logoUrl: "goodwill.png",
      name: "Goodwill",
      date: "9/15",
      category: ["Retail"],
      id: 94,
    },
    {
      logoUrl: "UBS.jpg",
      name: "UBS",
      date: "9/16",
      category: ["Financial Services"],
      id: 95,
    },
    {
      logoUrl: "buick.png",
      name: "Buick",
      date: "9/17",
      category: ["Automotive"],
      id: 96,
    },
    {
      logoUrl: "Humana.jpg",
      name: "Humana",
      date: "9/18",
      category: ["Healthcare"],
      id: 97,
    },
    {
      logoUrl: "tmobile.png",
      name: "T Mobile",
      date: "9/19",
      category: ["Tech"],
      id: 98,
    },
    {
      logoUrl: "VOLVO.jpg",
      name: "Volvo",
      date: "9/20",
      category: ["Automotive"],
      id: 99,
    },
    {
      logoUrl: "facebook.png",
      name: "Facebook",
      date: "9/21",
      category: ["Tech"],
      id: 100,
    },
    {
      logoUrl: "gazprom.png",
      name: "Gazprom",
      date: "9/22",
      category: ["Energy"],
      id: 101,
    },
    {
      logoUrl: "Toyota.png",
      name: "Toyota",
      date: "9/23",
      category: ["Automotive"],
      id: 102,
    },
    {
      logoUrl: "enterprise.png",
      name: "Enterprise",
      date: "9/24",
      category: ["Automotive"],
      id: 103,
    },
    {
      logoUrl: "scotiabank.png",
      name: "Scotiabank",
      date: "9/25",
      category: ["Financial Services"],
      id: 104,
    },
    {
      logoUrl: "Nescafe.png",
      name: "Nescafe",
      date: "9/26",
      category: ["Food & Beverage"],
      id: 105,
    },
    {
      logoUrl: "Rakuten.png",
      name: "Rakuten",
      date: "9/27",
      category: ["Tech"],
      id: 106,
    },
    {
      logoUrl: "Wendys.jpg",
      name: "Wendy's",
      date: "9/28",
      category: ["Food & Beverage"],
      id: 107,
    },
    {
      logoUrl: "bfgoodrich.png",
      name: "BF Goodrich",
      date: "9/29",
      category: ["Retail"],
      id: 108,
    },
    {
      logoUrl: "HCA.jpeg",
      name: "HCA Healthcare",
      date: "9/30",
      category: ["Healthcare"],
      id: 109,
    },
    {
      logoUrl: "Volkswagon.png",
      name: "Volkswagen",
      date: "10/1",
      category: ["Automotive"],
      id: 110,
    },
    {
      logoUrl: "tylenol.png",
      name: "Tylenol",
      date: "10/2",
      category: ["CPG"],
      id: 111,
    },
    {
      logoUrl: "uber.png",
      name: "Uber",
      date: "10/3",
      category: ["Tech"],
      id: 112,
    },
    {
      logoUrl: "exxonmobile.png",
      name: "Exxon Mobil",
      date: "10/4",
      category: ["Energy"],
      id: 113,
    },
    {
      logoUrl: "MiracleWhip.png",
      name: "Miracle Whip",
      date: "10/5",
      category: ["Food & Beverage"],
      id: 114,
    },
    {
      logoUrl: "MERCK.png",
      name: "MERCK",
      date: "10/6",
      category: ["Science"],
      id: 115,
    },
    {
      logoUrl: "subway.png",
      name: "Subway",
      date: "10/7",
      category: ["Food & Beverage"],
      id: 116,
    },
    {
      logoUrl: "Medtronic.jpg",
      name: "Medtronic",
      date: "10/8",
      category: ["Healthcare"],
      id: 117,
    },
    {
      logoUrl: "Instagram.png",
      name: "Instagram",
      date: "10/9",
      category: ["Tech"],
      id: 118,
    },
    {
      logoUrl: "McLane.gif",
      name: "McLane Company",
      date: "10/10",
      category: ["Food & Beverage"],
      id: 119,
    },
    {
      logoUrl: "AIRBUS.png",
      name: "Airbus",
      date: "10/11",
      category: ["Transportation"],
      id: 120,
    },
    {
      logoUrl: "nvidia.png",
      name: "NVIDIA",
      date: "10/12",
      category: ["Tech"],
      id: 121,
    },
    {
      logoUrl: "Dior.png",
      name: "Dior",
      date: "10/13",
      category: ["Retail"],
      id: 122,
    },
    {
      logoUrl: "suzuki.png",
      name: "Suzuki",
      date: "10/14",
      category: ["Automotive"],
      id: 123,
    },
    {
      logoUrl: "Nestle.jpg",
      name: "Nestle",
      date: "10/15",
      category: ["Food & Beverage"],
      id: 124,
    },
    {
      logoUrl: "Nike.png",
      name: "Nike",
      date: "10/16",
      category: ["Retail"],
      id: 125,
    },
    {
      logoUrl: "Canon.png",
      name: "Canon",
      date: "10/17",
      category: ["Tech"],
      id: 126,
    },
    {
      logoUrl: "Bloomberg.jpg",
      name: "Bloomberg",
      date: "10/18",
      category: ["Entertainment"],
      id: 127,
    },
    {
      logoUrl: "sysco.png",
      name: "Sysco",
      date: "10/19",
      category: ["Food & Beverage"],
      id: 128,
    },
    {
      logoUrl: "twitter.png",
      name: "Twitter",
      date: "10/20",
      category: ["Tech"],
      id: 129,
    },
    {
      logoUrl: "ralphs.png",
      name: "Ralphs",
      date: "10/21",
      category: ["Retail"],
      id: 130,
    },
    {
      logoUrl: "Roblox.png",
      name: "Roblox",
      date: "10/22",
      category: ["Tech"],
      id: 131,
    },
    {
      logoUrl: "wholefoods.png",
      name: "Whole Foods",
      date: "10/23",
      category: ["Retail"],
      id: 132,
    },
    {
      logoUrl: "Lexus.png",
      name: "Lexus",
      date: "10/24",
      category: ["Automotive"],
      id: 133,
    },
    {
      logoUrl: "Reliance.png",
      name: "Reliance Industries",
      date: "10/25",
      category: ["Energy"],
      id: 134,
    },
    {
      logoUrl: "ATT.png",
      name: "AT&T",
      date: "10/26",
      category: ["Tech"],
      id: 135,
    },
    {
      logoUrl: "CVS.jpg",
      name: "CVS",
      date: "10/27",
      category: ["Retail"],
      id: 136,
    },
    {
      logoUrl: "honeywell.png",
      name: "Honeywell",
      date: "10/28",
      category: ["Business Services"],
      id: 137,
    },
    {
      logoUrl: "TikTok.png",
      name: "TikTok",
      date: "10/29",
      category: ["Tech"],
      id: 138,
    },
    {
      logoUrl: "MAERSK.png",
      name: "MAERSK",
      date: "10/30",
      category: ["Logistics"],
      id: 139,
    },
    {
      logoUrl: "Infosys.png",
      name: "Infosys",
      date: "10/31",
      category: ["Professional Services"],
      id: 140,
    },
    {
      logoUrl: "Lay's.png",
      name: "Lay's",
      date: "11/1",
      category: ["Food & Beverage"],
      id: 141,
    },
    {
      logoUrl: "Speedo-Logo.jpeg",
      name: "Speedo",
      date: "11/2",
      category: ["CPG"],
      id: 142,
    },
    {
      logoUrl: "Buildabear.png",
      name: "Build-A-Bear",
      date: "11/3",
      category: ["Retail"],
      id: 143,
    },
    {
      logoUrl: "prosche.jpg",
      name: "Porsche",
      date: "11/4",
      category: ["Automotive"],
      id: 144,
    },
    {
      logoUrl: "dunkin.png",
      name: "Dunkin",
      date: "11/5",
      category: ["Food & Beverage"],
      id: 145,
    },
    {
      logoUrl: "CocaCola.png",
      name: "Coca-Cola",
      date: "11/6",
      category: ["Food & Beverage"],
      id: 146,
    },
    {
      logoUrl: "Merrill.png",
      name: "Merrill",
      date: "11/7",
      category: ["Financial Services"],
      id: 147,
    },
    {
      logoUrl: "LG.png",
      name: "LG",
      date: "11/8",
      category: ["Tech"],
      id: 148,
    },
    {
      logoUrl: "Spotify.png",
      name: "Spotify",
      date: "11/9",
      category: ["Tech"],
      id: 149,
    },
    {
      logoUrl: "linkedin.png",
      name: "LinkedIn",
      date: "11/10",
      category: ["Tech"],
      id: 150,
    },
    {
      logoUrl: "daveskiller.jpeg",
      name: "Dave's Killer Bread",
      date: "11/11",
      category: ["Food & Beverage"],
      id: 151,
    },
    {
      logoUrl: "ConocoPhillips.png",
      name: "Conoco Phillips",
      date: "11/12",
      category: ["Energy"],
      id: 152,
    },
    {
      logoUrl: "bic.svg",
      name: "Bic",
      date: "11/13",
      category: ["CPG"],
      id: 153,
    },
    {
      logoUrl: "Dominos.png",
      name: "Dominos",
      date: "11/14",
      category: ["Food & Beverage"],
      id: 154,
    },
    {
      logoUrl: "goldsgym.png",
      name: "Golds Gym",
      date: "11/15",
      category: ["Entertainment"],
      id: 155,
    },
    {
      logoUrl: "GEICO.jpeg",
      name: "GEICO",
      date: "11/16",
      category: ["Insurance"],
      id: 156,
    },
    {
      logoUrl: "NFL.png",
      name: "NFL",
      date: "11/17",
      category: ["Entertainment"],
      id: 157,
    },
    {
      logoUrl: "disney.png",
      name: "Disney",
      date: "11/18",
      category: ["Media"],
      id: 158,
    },
    {
      logoUrl: "Mckesson.png",
      name: "McKesson",
      date: "11/19",
      category: ["Healthcare"],
      id: 159,
    },
    {
      logoUrl: "appliedmaterials.jpg",
      name: "Applied Materials",
      date: "11/20",
      category: ["Science"],
      id: 160,
    },
    {
      logoUrl: "lidl.png",
      name: "LIDL",
      date: "11/21",
      category: ["Retail"],
      id: 161,
    },
    {
      logoUrl: "Corona.png",
      name: "Corona",
      date: "11/22",
      category: ["Food & Beverage"],
      id: 162,
    },
    {
      logoUrl: "TraderJoes.png",
      name: "Trader's Joes",
      date: "11/23",
      category: ["Retail"],
      id: 163,
    },
    {
      logoUrl: "vmware.png",
      name: "VMWARE",
      date: "11/24",
      category: ["Tech"],
      id: 164,
    },
    {
      logoUrl: "Levis.png",
      name: "Levi's",
      date: "11/25",
      category: ["CPG"],
      id: 165,
    },
    {
      logoUrl: "pepsi.png",
      name: "Pepsi",
      date: "11/26",
      category: ["Food & Beverage"],
      id: 166,
    },
    {
      logoUrl: "pnc.png",
      name: "PNC",
      date: "11/27",
      category: ["Financial Services"],
      id: 167,
    },
    {
      logoUrl: "Accenture.png",
      name: "Accenture",
      date: "11/28",
      category: ["Information Technology"],
      id: 168,
    },
    {
      logoUrl: "EA.png",
      name: "Electronic Arts",
      date: "11/29",
      category: ["Tech"],
      id: 169,
    },
    {
      logoUrl: "MARVEL.png",
      name: "Marvel",
      date: "11/30",
      category: ["Entertainment"],
      id: 170,
    },
    {
      logoUrl: "bridgestone.png",
      name: "Bridgestone",
      date: "12/1",
      category: ["Automotive"],
      id: 171,
    },
    {
      logoUrl: "chevrolet.png",
      name: "Chevrolet",
      date: "12/2",
      category: ["Automotive"],
      id: 172,
    },
    {
      logoUrl: "baidu.png",
      name: "Baidu",
      date: "12/3",
      category: ["Tech"],
      id: 173,
    },
    {
      logoUrl: "cummins.png",
      name: "Cummins",
      date: "12/4",
      category: ["Machinery"],
      id: 174,
    },
    {
      logoUrl: "Qualcomm.png",
      name: "Qualcomm",
      date: "12/5",
      category: ["Tech"],
      id: 175,
    },
    {
      logoUrl: "Allstate.jpg",
      name: "Allstate",
      date: "12/6",
      category: ["Insurance"],
      id: 176,
    },
    {
      logoUrl: "Tinder-Logo.png",
      name: "Tinder",
      date: "12/7",
      category: ["Tech"],
      id: 177,
    },
    {
      logoUrl: "reebok.jpeg",
      name: "Reebok",
      date: "12/8",
      category: ["CPG"],
      id: 178,
    },
    {
      logoUrl: "usbank.png",
      name: "US Bank",
      date: "12/9",
      category: ["Financial Services"],
      id: 179,
    },
    {
      logoUrl: "emirates.png",
      name: "Emirates",
      date: "12/10",
      category: ["Transportation"],
      id: 180,
    },
    {
      logoUrl: "RBC.png",
      name: "RBC",
      date: "12/11",
      category: ["Financial Services"],
      id: 181,
    },
    {
      logoUrl: "hp.png",
      name: "HP",
      date: "12/12",
      category: ["Tech"],
      id: 182,
    },
    {
      logoUrl: "M&Ms.png",
      name: "M&Ms",
      date: "12/13",
      category: ["Food & Beverage"],
      id: 183,
    },
    {
      logoUrl: "Activision.png",
      name: "Activision Blizzard",
      date: "12/14",
      category: ["Tech"],
      id: 184,
    },
    {
      logoUrl: "sherwinwilliams.png",
      name: "Sherwin Williams",
      date: "12/15",
      category: ["Retail"],
      id: 185,
    },
    {
      logoUrl: "DC.png",
      name: "DC Comics",
      date: "12/16",
      category: ["Entertainment"],
      id: 186,
    },
    {
      logoUrl: "progressive.jpeg",
      name: "Progressive",
      date: "12/17",
      category: ["Insurance"],
      id: 187,
    },
    {
      logoUrl: "SoftBank.jpg",
      name: "SoftBank",
      date: "12/18",
      category: ["Financial Services"],
      id: 188,
    },
    {
      logoUrl: "Purina.png",
      name: "Purina",
      date: "12/19",
      category: ["CPG"],
      id: 189,
    },
    {
      logoUrl: "Kohls.png",
      name: "KOHL'S",
      date: "12/20",
      category: ["Retail"],
      id: 190,
    },
    {
      logoUrl: "GameStop.png",
      name: "GameStop",
      date: "12/21",
      category: ["Retail"],
      id: 191,
    },
    {
      logoUrl: "Spirit.png",
      name: "Spirit Airlines",
      date: "12/22",
      category: ["Transportation"],
      id: 192,
    },
    {
      logoUrl: "Pantene.png",
      name: "Pantene",
      date: "12/23",
      category: ["CPG"],
      id: 193,
    },
    {
      logoUrl: "DANONE.png",
      name: "DANONE",
      date: "12/24",
      category: ["Food & Beverage"],
      id: 194,
    },
    {
      logoUrl: "IGLOO.png",
      name: "IGLOO",
      date: "12/25",
      category: ["Retail"],
      id: 195,
    },
    {
      logoUrl: "BASF.jpg",
      name: "BASF",
      date: "12/26",
      category: ["Science"],
      id: 196,
    },
    {
      logoUrl: "citi.jpg",
      name: "Citi",
      date: "12/27",
      category: ["Financial Services"],
      id: 197,
    },
    {
      logoUrl: "Bayer.jpg",
      name: "Bayer",
      date: "12/28",
      category: ["Science"],
      id: 198,
    },
    {
      logoUrl: "Allstate.png",
      name: "Allstate",
      date: "12/29",
      category: ["Insurance"],
      id: 199,
    },
    {
      logoUrl: "bofa.png",
      name: "Bank of America",
      date: "12/30",
      category: ["Financial Services"],
      id: 200,
    },
    {
      logoUrl: "WellsFargo.png",
      name: "Wells Fargo",
      date: "12/31",
      category: ["Financial Services"],
      id: 201,
    },
    {
      logoUrl: "MLB.png",
      name: "MLB",
      date: "1/1",
      category: ["Entertainment"],
      id: 202,
    },
    {
      logoUrl: "capitalone.jpg",
      name: "Capital One",
      date: "1/2",
      category: ["Financial Services"],
      id: 203,
    },
    {
      logoUrl: "20thCenturyTelevision.png",
      name: "20th Television",
      date: "1/3",
      category: ["Entertainment"],
      id: 204,
    },
    {
      logoUrl: "intel.jpg",
      name: "Intel",
      date: "1/4",
      category: ["Tech"],
      id: 205,
    },
    {
      logoUrl: "michelin.png",
      name: "Michelin",
      date: "1/5",
      category: ["Automotive"],
      id: 206,
    },
    {
      logoUrl: "United.png",
      name: "United",
      date: "1/6",
      category: ["Transportation"],
      id: 207,
    },
    {
      logoUrl: "Movistar.png",
      name: "Movistar",
      date: "1/7",
      category: ["Entertainment"],
      id: 208,
    },
    {
      logoUrl: "Caterpillar.jpg",
      name: "Caterpillar",
      date: "1/8",
      category: ["Heavy Equipment"],
      id: 209,
    },
    {
      logoUrl: "Rolex.png",
      name: "Rolex",
      date: "1/9",
      category: ["Retail"],
      id: 210,
    },
    {
      logoUrl: "Ferrari.png",
      name: "Ferrari",
      date: "1/10",
      category: ["Automotive"],
      id: 211,
    },
    {
      logoUrl: "dish.png",
      name: "Dish",
      date: "1/11",
      category: ["Entertainment"],
      id: 212,
    },
    {
      logoUrl: "Prudential.jpg",
      name: "Prudential",
      date: "1/12",
      category: ["Insurance"],
      id: 213,
    },
    {
      logoUrl: "heineken.png",
      name: "Heineken",
      date: "1/13",
      category: ["Food & Beverage"],
      id: 214,
    },
    {
      logoUrl: "Booking.png",
      name: "Booking.com",
      date: "1/14",
      category: ["Travel"],
      id: 215,
    },
    {
      logoUrl: "Marlboro.png",
      name: "Marlboro",
      date: "1/15",
      category: ["CPG"],
      id: 216,
    },
    {
      logoUrl: "Budweiser.png",
      name: "Budweiser",
      date: "1/16",
      category: ["Food & Beverage"],
      id: 217,
    },
    {
      logoUrl: "Louisvoutton.jpg",
      name: "Louis Vuitton",
      date: "1/17",
      category: ["Retail"],
      id: 218,
    },
    {
      logoUrl: "alibaba.png",
      name: "Alibaba",
      date: "1/18",
      category: ["Retail"],
      id: 219,
    },
    {
      logoUrl: "whataburger.png",
      name: "Whataburger",
      date: "1/19",
      category: ["Food & Beverage"],
      id: 220,
    },
    {
      logoUrl: "FOX.jpg",
      name: "FOX",
      date: "1/20",
      category: ["Entertainment"],
      id: 221,
    },
    {
      logoUrl: "persol.png",
      name: "Persol",
      date: "1/21",
      category: ["CPG"],
      id: 222,
    },
    {
      logoUrl: "redbull.png",
      name: "Red Bull",
      date: "1/22",
      category: ["Food & Beverage"],
      id: 223,
    },
    {
      logoUrl: "CHANEL.png",
      name: "CHANEL",
      date: "1/23",
      category: ["Retail"],
      id: 224,
    },
    {
      logoUrl: "kelloggs.png",
      name: "Kellogg's",
      date: "1/24",
      category: ["Food & Beverage"],
      id: 225,
    },
    {
      logoUrl: "lockheedmartin.jpg",
      name: "Lockheed Martin",
      date: "1/25",
      category: ["Transportation"],
      id: 226,
    },
    {
      logoUrl: "Weezer.png",
      name: "Weezer",
      date: "1/26",
      category: ["Music"],
      id: 227,
    },
    {
      logoUrl: "airtel.png",
      name: "Airtel",
      date: "1/27",
      category: ["Information Technology"],
      id: 228,
    },
    {
      logoUrl: "MSNBC_2021.png",
      name: "MSN",
      date: "1/28",
      category: ["Entertainment"],
      id: 229,
    },
    {
      logoUrl: "gillette.png",
      name: "Gillette",
      date: "1/29",
      category: ["CPG"],
      id: 230,
    },
    {
      logoUrl: "charlesschwab.jpg",
      name: "Charles Schwab",
      date: "1/30",
      category: ["Financial Services"],
      id: 231,
    },
    {
      logoUrl: "Marshalls.png",
      name: "Marshalls",
      date: "1/31",
      category: ["Retail"],
      id: 232,
    },
    {
      logoUrl: "Olympics.png",
      name: "Olympics",
      date: "2/1",
      category: ["Entertainment"],
      id: 233,
    },
    {
      logoUrl: "edf.png",
      name: "EDF",
      date: "2/2",
      category: ["NonProfit"],
      id: 234,
    },
    {
      logoUrl: "Pampers.png",
      name: "Pampers",
      date: "2/3",
      category: ["CPG"],
      id: 235,
    },
    {
      logoUrl: "Comedycentral.png",
      name: "Comedy Central",
      date: "2/4",
      category: ["Entertainment"],
      id: 236,
    },
    {
      logoUrl: "Raytheon.png",
      name: "Raytheon",
      date: "2/5",
      category: ["Science"],
      id: 237,
    },
    {
      logoUrl: "Lloydsbank.png",
      name: "Lloyds Bank",
      date: "2/6",
      category: ["Financial Services"],
      id: 238,
    },
    {
      logoUrl: "BristolMyersSquibb.png",
      name: "Bristol Myers Squibb",
      date: "2/7",
      category: ["Science"],
      id: 239,
    },
    {
      logoUrl: "landrover.jpg",
      name: "Land Rover",
      date: "2/8",
      category: ["Automotive"],
      id: 240,
    },
    {
      logoUrl: "Mcdonalds.png",
      name: "McDonalds",
      date: "2/9",
      category: ["Food & Beverage"],
      id: 241,
    },
    {
      logoUrl: "Carrefour.jpg",
      name: "Carrefour",
      date: "2/10",
      category: ["Retail"],
      id: 242,
    },
    {
      logoUrl: "ikea.jpg",
      name: "IKEA",
      date: "2/11",
      category: ["Retail"],
      id: 243,
    },
    {
      logoUrl: "barclays.jpg",
      name: "Barclays",
      date: "2/12",
      category: ["Financial Services"],
      id: 244,
    },
    {
      logoUrl: "Nissan.jpg",
      name: "Nissan",
      date: "2/13",
      category: ["Automotive"],
      id: 245,
    },
    {
      logoUrl: "Subura.png",
      name: "Subaru",
      date: "2/14",
      category: ["Automotive"],
      id: 246,
    },
    {
      logoUrl: "Delta.jpg",
      name: "Delta",
      date: "2/15",
      category: ["Transportation"],
      id: 247,
    },
    {
      logoUrl: "orangetheory.png",
      name: "Orange Theory",
      date: "2/16",
      category: ["Entertainment"],
      id: 248,
    },
    {
      logoUrl: "Spectrum.jpg",
      name: "Spectrum",
      date: "2/17",
      category: ["Tech"],
      id: 249,
    },
    {
      logoUrl: "Warnerbros.png",
      name: "Warner Bros",
      date: "2/18",
      category: ["Entertainment"],
      id: 250,
    },
    {
      logoUrl: "Metlife.jpg",
      name: "MetLife",
      date: "2/19",
      category: ["Insurance"],
      id: 251,
    },
    {
      logoUrl: "Universal.png",
      name: "Universal",
      date: "2/20",
      category: ["Entertainment"],
      id: 252,
    },
    {
      logoUrl: "siemens.png",
      name: "Siemens",
      date: "2/21",
      category: ["Automation"],
      id: 253,
    },
    {
      logoUrl: "chubb.png",
      name: "Chubb",
      date: "2/22",
      category: ["Insurance"],
      id: 254,
    },
    {
      logoUrl: "hermes.png",
      name: "Hermes",
      date: "2/23",
      category: ["Retail"],
      id: 255,
    },
    {
      logoUrl: "sky.png",
      name: "Sky",
      date: "2/24",
      category: ["Entertainment"],
      id: 256,
    },
    {
      logoUrl: "JJ.png",
      name: "Johnson & Johnson",
      date: "2/25",
      category: ["Healthcare"],
      id: 257,
    },
    {
      logoUrl: "hellobello.svg",
      name: "Hello Bello",
      date: "2/26",
      category: ["CPG"],
      id: 258,
    },
    {
      logoUrl: "Brita.png",
      name: "Brita",
      date: "2/27",
      category: ["CPG"],
      id: 259,
    },
    {
      logoUrl: "Hyundai.png",
      name: "Hyundai",
      date: "2/28",
      category: ["Automotive"],
      id: 260,
    },
    {
      logoUrl: "greenpeace.png",
      name: "Greenpeace",
      date: "2/29",
      category: ["NonProfit"],
      id: 261,
    },
    {
      logoUrl: "CNBC.png",
      name: "CNBC",
      date: "3/1",
      category: ["Entertainment"],
      id: 262,
    },
    {
      logoUrl: "Visa.png",
      name: "Visa",
      date: "3/2",
      category: ["Financial Services"],
      id: 263,
    },
    {
      logoUrl: "bmw.png",
      name: "BMW",
      date: "3/3",
      category: ["Automotive"],
      id: 264,
    },
    {
      logoUrl: "ING.png",
      name: "ING",
      date: "3/4",
      category: ["Financial Services"],
      id: 265,
    },
    {
      logoUrl: "711.png",
      name: "7-Eleven",
      date: "3/5",
      category: ["Retail"],
      id: 266,
    },
    {
      logoUrl: "Mitsubishi.png",
      name: "Mitsubishi Corporation",
      date: "3/6",
      category: ["Automotive"],
      id: 267,
    },
    {
      logoUrl: "Roche.jpeg",
      name: "Roche",
      date: "3/7",
      category: ["Healthcare"],
      id: 268,
    },
    {
      logoUrl: "Nivea.png",
      name: "Nivea",
      date: "3/8",
      category: ["Retail"],
      id: 269,
    },
    {
      logoUrl: "Tacobell.png",
      name: "Taco Bell",
      date: "3/9",
      category: ["Food & Beverage"],
      id: 270,
    },
    {
      logoUrl: "COACH.jpg",
      name: "Coach",
      date: "3/10",
      category: ["CPG"],
      id: 271,
    },
    {
      logoUrl: "Dell.jpeg",
      name: "Dell Technologies",
      date: "3/11",
      category: ["Tech"],
      id: 272,
    },
    {
      logoUrl: "Autozone.png",
      name: "Auto Zone",
      date: "3/12",
      category: ["Retail"],
      id: 273,
    },
    {
      logoUrl: "verizon.jpg",
      name: "Verizon",
      date: "3/13",
      category: ["Retail"],
      id: 274,
    },
    {
      logoUrl: "AmericanAirlines.png",
      name: "American Airlines",
      date: "3/14",
      category: ["Travel"],
      id: 275,
    },
    {
      logoUrl: "Quaker.png",
      name: "Quaker",
      date: "3/15",
      category: ["Food & Beverage"],
      id: 276,
    },
    {
      logoUrl: "Rabobank.png",
      name: "Rabobank",
      date: "3/16",
      category: ["Financial Services"],
      id: 277,
    },
    {
      logoUrl: "tencent.png",
      name: "Tencent",
      date: "3/17",
      category: ["Tech"],
      id: 278,
    },
    {
      logoUrl: "dollargeneral.jpg",
      name: "Dollar General",
      date: "3/18",
      category: ["Retail"],
      id: 279,
    },
    {
      logoUrl: "InNOut_2021_logo.png",
      name: "In-N-Out",
      date: "3/19",
      category: ["Food & Beverage"],
      id: 280,
    },
    {
      logoUrl: "O2.jpeg",
      name: "O2",
      date: "3/20",
      category: ["Tech"],
      id: 281,
    },
    {
      logoUrl: "zalando.png",
      name: "Zalando",
      date: "3/21",
      category: ["Retail"],
      id: 282,
    },
    {
      logoUrl: "sephora.png",
      name: "Sephora",
      date: "3/22",
      category: ["Retail"],
      id: 283,
    },
    {
      logoUrl: "Audi.jpg",
      name: "Audi",
      date: "3/23",
      category: ["Automotive"],
      id: 284,
    },
    {
      logoUrl: "Cognizant.png",
      name: "Cognizant",
      date: "3/24",
      category: ["Information Technology"],
      id: 285,
    },
    {
      logoUrl: "PallMall.jpg",
      name: "Pall Mall",
      date: "3/25",
      category: ["CPG"],
      id: 286,
    },
    {
      logoUrl: "overstock.png",
      name: "Overstock",
      date: "3/26",
      category: ["Retail"],
      id: 287,
    },
    {
      logoUrl: "CreditSuisse.png",
      name: "Credit Suisse",
      date: "3/27",
      category: ["Financial Services"],
      id: 288,
    },
    {
      logoUrl: "SAP.jpg",
      name: "SAP",
      date: "3/28",
      category: ["Tech"],
      id: 289,
    },
    {
      logoUrl: "Nintendo.png",
      name: "Nintendo",
      date: "3/29",
      category: ["Tech"],
      id: 290,
    },
    {
      logoUrl: "H&M.png",
      name: "H&M",
      date: "3/30",
      category: ["Retail"],
      id: 291,
    },
    {
      logoUrl: "paypal.png",
      name: "PayPal",
      date: "3/31",
      category: ["Financial Services"],
      id: 292,
    },
    {
      logoUrl: "Clinique.png",
      name: "Clinique",
      date: "4/1",
      category: ["CPG"],
      id: 293,
    },
    {
      logoUrl: "netflix.jpg",
      name: "Netflix",
      date: "4/2",
      category: ["Tech"],
      id: 294,
    },
    {
      logoUrl: "USAA.png",
      name: "USAA",
      date: "4/3",
      category: ["Food & Beverage"],
      id: 295,
    },
    {
      logoUrl: "BURBERRY.png",
      name: "Burberry",
      date: "4/4",
      category: ["Tech"],
      id: 296,
    },
    {
      logoUrl: "bestbuy.png",
      name: "Best Buy",
      date: "4/5",
      category: ["Retail"],
      id: 297,
    },
    {
      logoUrl: "mastercard.png",
      name: "Mastercard",
      date: "4/6",
      category: ["Financial Services"],
      id: 298,
    },
    {
      logoUrl: "Santander.png",
      name: "Santander",
      date: "4/7",
      category: ["Financial Services"],
      id: 299,
    },
    {
      logoUrl: "KPMG.png",
      name: "KPMG",
      date: "4/8",
      category: ["Professional Services"],
      id: 300,
    },
    {
      logoUrl: "l&m.png",
      name: "L&M",
      date: "4/9",
      category: ["Retail"],
      id: 301,
    },
    {
      logoUrl: "Dove.png",
      name: "Dove",
      date: "4/10",
      category: ["CPG"],
      id: 302,
    },
    {
      logoUrl: "starbucks.png",
      name: "Starbucks",
      date: "4/11",
      category: ["Retail"],
      id: 303,
    },
    {
      logoUrl: "SPANX.png",
      name: "Spanx",
      date: "4/12",
      category: ["Retail"],
      id: 304,
    },
    {
      logoUrl: "pfizer.jpg",
      name: "Pfizer",
      date: "4/13",
      category: ["Healthcare"],
      id: 305,
    },
    {
      logoUrl: "halo.png",
      name: "Halo",
      date: "4/14",
      category: ["Tech"],
      id: 306,
    },
    {
      logoUrl: "Supreme.png",
      name: "Supreme",
      date: "4/15",
      category: ["CPG"],
      id: 307,
    },
    {
      logoUrl: "Zildjian_Logo.png",
      name: "Zildjian",
      date: "4/16",
      category: ["Music"],
      id: 308,
    },
    {
      logoUrl: "petronas.jpg",
      name: "Petronas",
      date: "4/17",
      category: ["Energy"],
      id: 309,
    },
    {
      logoUrl: "Claro.png",
      name: "Claro",
      date: "4/18",
      category: ["Tech"],
      id: 310,
    },
    {
      logoUrl: "amex.png",
      name: "American Express",
      date: "4/19",
      category: ["Financial Services"],
      id: 311,
    },
    {
      logoUrl: "IBM.jpg",
      name: "IBM",
      date: "4/20",
      category: ["Tech"],
      id: 312,
    },
    {
      logoUrl: "BlackRock.png",
      name: "BlackRock",
      date: "4/21",
      category: ["Professional Services"],
      id: 313,
    },
    {
      logoUrl: "tesla.png",
      name: "Tesla",
      date: "4/22",
      category: ["Automotive"],
      id: 314,
    },
    {
      logoUrl: "atari-logo-white-on-red-01.jpeg",
      name: "Atari",
      date: "4/23",
      category: ["Tech"],
      id: 315,
    },
    {
      logoUrl: "Kroger.png",
      name: "Kroger",
      date: "4/24",
      category: ["Retail"],
      id: 316,
    },
    {
      logoUrl: "Victoria'sSecret.png",
      name: "Victoria's Secret",
      date: "4/25",
      category: ["Retail"],
      id: 317,
    },
    {
      logoUrl: "McKinsey.png",
      name: "McKinsey & Company",
      date: "4/26",
      category: ["Professional Services"],
      id: 318,
    },
    {
      logoUrl: "oracle.png",
      name: "Oracle",
      date: "4/27",
      category: ["Tech"],
      id: 319,
    },
    {
      logoUrl: "S&PGlobal.png",
      name: "S&P Global",
      date: "4/28",
      category: ["Information Technology"],
      id: 320,
    },
    {
      logoUrl: "CommonWealth.png",
      name: "CommonWealth",
      date: "4/29",
      category: ["Financial Services"],
      id: 321,
    },
    {
      logoUrl: "InternationalCricketCouncil.png",
      name: "International Cricket Council",
      date: "4/30",
      category: ["Tech"],
      id: 322,
    },
    {
      logoUrl: "bitcoin.png",
      name: "Bitcoin",
      date: "5/1",
      category: ["Tech"],
      id: 323,
    },
    {
      logoUrl: "FedEx.png",
      name: "FedEx",
      date: "5/2",
      category: ["Logistics"],
      id: 324,
    },
    {
      logoUrl: "JPMorgan.png",
      name: "J.P.Morgan",
      date: "5/3",
      category: ["Financial Services"],
      id: 325,
    },
    {
      logoUrl: "Jeep.png",
      name: "Jeep",
      date: "5/4",
      category: ["Automotive"],
      id: 326,
    },
    {
      logoUrl: "BNParibas.png",
      name: "BNP Paribas",
      date: "5/5",
      category: ["Financial Services"],
      id: 327,
    },
    {
      logoUrl: "USPS.jpg",
      name: "United States Postal Service",
      date: "5/6",
      category: ["Logistics"],
      id: 328,
    },
    {
      logoUrl: "tapatio.jpeg",
      name: "Tapatio",
      date: "5/7",
      category: ["Food & Beverage"],
      id: 329,
    },
    {
      logoUrl: "CBS.png",
      name: "CBS",
      date: "5/8",
      category: ["Entertainment"],
      id: 330,
    },
    {
      logoUrl: "homedepot.png",
      name: "The Home Depot",
      date: "5/9",
      category: ["Retail"],
      id: 331,
    },
    {
      logoUrl: "Apple.png",
      name: "Apple",
      date: "5/10",
      category: ["Tech"],
      id: 332,
    },
    {
      logoUrl: "DBS.jpg",
      name: "DBS",
      date: "5/11",
      category: ["Financial Services"],
      id: 333,
    },
    {
      logoUrl: "Southwest.png",
      name: "Southwest",
      date: "5/12",
      category: ["Transportation"],
      id: 334,
    },
    {
      logoUrl: "Micron.png",
      name: "Micron",
      date: "5/13",
      category: ["Tech"],
      id: 335,
    },
    {
      logoUrl: "Lowes.jpg",
      name: "Lowe's",
      date: "5/14",
      category: ["Retail"],
      id: 336,
    },
    {
      logoUrl: "youtube.jpg",
      name: "Youtube",
      date: "5/15",
      category: ["Tech"],
      id: 337,
    },
    {
      logoUrl: "UnionPacific.png",
      name: "Union Pacific",
      date: "5/16",
      category: ["Travel"],
      id: 338,
    },
    {
      logoUrl: "phillips.png",
      name: "Philips",
      date: "5/17",
      category: ["Tech"],
      id: 339,
    },
    {
      logoUrl: "MB.png",
      name: "Mercedes-Benz",
      date: "5/18",
      category: ["Automotive"],
      id: 340,
    },
    {
      logoUrl: "Valero.png",
      name: "Valero",
      date: "5/19",
      category: ["Energy"],
      id: 341,
    },
    {
      logoUrl: "gerber.png",
      name: "Gerber",
      date: "5/20",
      category: ["Food & Beverage"],
      id: 342,
    },
    {
      logoUrl: "JohnDeere.jpg",
      name: "John Deere",
      date: "5/21",
      category: ["Heavy Equipment"],
      id: 343,
    },
    {
      logoUrl: "Esteelauder.png",
      name: "Estee Lauder",
      date: "5/22",
      category: ["Retail"],
      id: 344,
    },
    {
      logoUrl: "AMD.jpg",
      name: "AMD",
      date: "5/23",
      category: ["Tech"],
      id: 345,
    },
    {
      logoUrl: "wayfair.png",
      name: "Wayfair",
      date: "5/24",
      category: ["Retail"],
      id: 346,
    },
    {
      logoUrl: "Topochico.jpeg",
      name: "Topo Chico",
      date: "5/25",
      category: ["Food & Beverage"],
      id: 347,
    },
    {
      logoUrl: "huawei.png",
      name: "Huawei",
      date: "5/26",
      category: ["Tech"],
      id: 348,
    },
    {
      logoUrl: "XBOX.png",
      name: "XBOX",
      date: "5/27",
      category: ["Entertainment"],
      id: 349,
    },
    {
      logoUrl: "Carmax.png",
      name: "Carmax",
      date: "5/28",
      category: ["Automotive"],
      id: 350,
    },
    {
      logoUrl: "Stjude.png",
      name: "St. Jude Children's Research Hospital",
      date: "5/29",
      category: ["Science"],
      id: 351,
    },
    {
      logoUrl: "HEINZ.png",
      name: "Heinz",
      date: "5/30",
      category: ["Food & Beverage"],
      id: 352,
    },
    {
      logoUrl: "Adobe.png",
      name: "Adobe",
      date: "5/31",
      category: ["Tech"],
      id: 353,
    },
    {
      logoUrl: "allianz.png",
      name: "Allianz",
      date: "6/1",
      category: ["Financial Services"],
      id: 354,
    },
    {
      logoUrl: "ESPN.png",
      name: "ESPN",
      date: "6/2",
      category: ["Entertainment"],
      id: 355,
    },
    {
      logoUrl: "discover.png",
      name: "Discover",
      date: "6/3",
      category: ["Financial Services"],
      id: 356,
    },
    {
      logoUrl: "DHL.jpg",
      name: "DHL",
      date: "6/4",
      category: ["Logistics"],
      id: 357,
    },
    {
      logoUrl: "CIBC.jpg",
      name: "CIBC",
      date: "6/5",
      category: ["Financial Services"],
      id: 358,
    },
    {
      logoUrl: "Gucci.png",
      name: "Gucci",
      date: "6/6",
      category: ["Retail"],
      id: 359,
    },
    {
      logoUrl: "Hitachi.png",
      name: "Hitachi",
      date: "6/7",
      category: ["Tech"],
      id: 360,
    },
    {
      logoUrl: "woolworths.jpg",
      name: "Woolworths",
      date: "6/8",
      category: ["Food & Beverage"],
      id: 361,
    },
    {
      logoUrl: "omega.png",
      name: "Omega",
      date: "6/9",
      category: ["CPG"],
      id: 362,
    },
    {
      logoUrl: "Sprite.png",
      name: "Sprite",
      date: "6/10",
      category: ["Food & Beverage"],
      id: 363,
    },
    {
      logoUrl: "Playstation.jpg",
      name: "Playstation",
      date: "6/11",
      category: ["Tech"],
      id: 364,
    },
    {
      logoUrl: "Adidas.jpg",
      name: "Adidas",
      date: "6/12",
      category: ["CPG"],
      id: 365,
    },
    {
      logoUrl: "GE.png",
      name: "General Electric",
      date: "6/13",
      category: ["Tech"],
      id: 366,
    },
  ],
};
